import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import ApiRequest from "../../../helper/ApiRequest";
import CustomSelect from "../../../component/CustomSelect";
import CustomImageUpload from "../../../component/CustomImageUpload";
import DynamicCKEditor from "../../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";
import { Link } from "react-router-dom";

const addLocServiceEndpoint = ApiEndpoints.locService.locServiceCreate;
const categoryListEndpoint = ApiEndpoints.Dynamiccategory.categoryList;

const userName = !localStorage.getItem("username") ? "Admin" : localStorage.getItem("username");

export default function AddLogisticsService() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);


  const [previews, setPreviews] = useState({ section2_icon1: null, section1_image: null, section2_icon2: null, section2_icon3: null, section2_image: null, section8_author_image: null, section7_icon1: null, section7_icon2: null, section7_icon3: null, page_image:null, page_menu_image:null });

  const [postData, setPostData] = useState({
    dynamic_page_category_id: "", page_name:"", page_image:null, page_description:"", slug: "", page_menu_image:null, section1_rating: "", section1_total_reviews: "", section1_title: "", section1_description: "", section1_alt_image: "", section1_image: null, section2_icon1: null, section2_title1: "", section2_description1: "", section2_icon2: null, section2_title2: "", section2_description2: "", section2_icon3: null, section2_title3: "", section2_description3: "", section2_image: null, section2_alt_image: "", section3_heading: "", section3_description: "", section5_title: "", section5_description: "",
    section6_stat_count1: "", section6_stat_heading1: "", section6_stat_description1: "", section6_stat_count2: "", section7_heading: "", section8_author_image: null, section6_stat_heading2: "", section6_stat_description2: "", section6_stat_count3: "", section6_stat_heading3: "", section6_stat_description3: "", section6_stat_count4: "", section6_stat_heading4: "", section6_stat_description4: "", section7_icon1: null, section7_description1: "", section7_author1: "", section7_designation1: "", section7_icon2: null, section7_description2: "", section7_author2: "", section7_designation2: "", section7_icon3: null, section7_description3: "", section7_author3: "", section7_designation3: "", section8_title: "", section8_description: "", section8_right_side_title: "", section8_author: "", section8_designation: "", section8_cta_text: "", section8_cta_link: "",

    section3_points: [
      { heading: "", description: "", icon: null, image: null },
    ],
    section5_points: [
      { heading: "", description: "", icon: null },
    ],
  });


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await ApiRequest("GET", categoryListEndpoint);
        setCategories(response?.dynamic_page_categories || []);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
        setCategories([]);
      }
    };
    fetchCategories();
  }, []);


  const handleChange = (e) => {
    const { name, value, files } = e.target;

    const finalValue = files ? files[0] : value;

    setPostData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    if (files) {
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(files[0]),
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prev) => ({
      ...prev,
      [key]: data,
    }));
  };

  // ================= SECTION 3 =================
  const handleSection3Change = (index, field, value) => {
    const updated = [...postData.section3_points];
    updated[index][field] = value;

    setPostData((prev) => ({
      ...prev,
      section3_points: updated,
    }));
  };

  const handleAddMoreSection3 = (e) => {
    e.preventDefault();

    if (postData.section3_points.length >= 10) {
      toast.warning("Max 10 allowed");
      return;
    }

    setPostData((prev) => ({
      ...prev,
      section3_points: [
        ...prev.section3_points,
        { heading: "", description: "", icon: null, image: null },
      ],
    }));
  };

  const handleRemoveSection3 = (index) => {
    if (postData.section3_points.length === 1) return;

    const updated = postData.section3_points.filter((_, i) => i !== index);

    setPostData((prev) => ({
      ...prev,
      section3_points: updated,
    }));
  };

  // ================= SECTION 5 =================
  const handleSection5Change = (index, field, value) => {
    const updated = [...postData.section5_points];
    updated[index][field] = value;

    setPostData((prev) => ({
      ...prev,
      section5_points: updated,
    }));
  };

  const handleAddMoreSection5 = (e) => {
    e.preventDefault();

    if (postData.section5_points.length >= 10) {
      toast.warning("Max 10 allowed");
      return;
    }

    setPostData((prev) => ({
      ...prev,
      section5_points: [
        ...prev.section5_points,
        { heading: "", description: "", icon: null },
      ],
    }));
  };

  const handleRemoveSection5 = (index) => {
    if (postData.section5_points.length === 1) return;

    const updated = postData.section5_points.filter((_, i) => i !== index);

    setPostData((prev) => ({
      ...prev,
      section5_points: updated,
    }));
  };
  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    const ignoreFields = ["_id", "__v", "createdAt", "updatedAt"];

    // ================= VALIDATION =================
    for (const [key, value] of Object.entries(postData)) {
      if (ignoreFields.includes(key)) continue;
      if (Array.isArray(value)) continue;
      if (!value) {
        toast.error(`${key} is required`);
        return;
      }
    }

    // section3 validation
    for (let i = 0; i < postData.section3_points.length; i++) {
      const item = postData.section3_points[i];
      if (!item.heading || !item.description || !item.icon || !item.image) {
        toast.error(`Section3 item ${i + 1} incomplete`);
        return;
      }
    }

    // section5 validation
    for (let i = 0; i < postData.section5_points.length; i++) {
      const item = postData.section5_points[i];
      if (!item.heading || !item.description || !item.icon) {
        toast.error(`Section5 item ${i + 1} incomplete`);
        return;
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      if (ignoreFields.includes(key)) return;
      if (Array.isArray(value)) {
        value.forEach((item, i) => {
          if (item.icon) {
            formData.append(`${key}[${i}][icon]`, item.icon);
          }
          if (item.image) {
            formData.append(`${key}[${i}][image]`, item.image);
          }


        });
        const cleanArray = value.map(item => {
          const { icon, image, ...rest } = item;
          return rest;
        });
        formData.append(key, JSON.stringify(cleanArray));
      } else {
        formData.append(key, value);
      }
    });

    try {
      const response = await ApiRequest("POST", addLocServiceEndpoint, formData, {
        headers: { "Content-Type": "multipart/form-data", },
      });
      toast.success(response.message);
      navigate("/logistic");
    } catch (error) {
      toast.error("Form data is too large. Please add less fields than add remaining in edit.");
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: 'Logistic Service Management',
    user: 'Admin',
    innerpage: 'Logistic Service Management / Service / Add Logistic'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="blogAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Page Name<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="page_name" type="text" className="form-control" placeholder="Enter Page Name" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

                <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Header Menu  Image  (602 × 580 px)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="page_menu_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.page_menu_image}
                  />
                </div>
              </div>



              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>category<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="dynamic_page_category_id" options={categories} placeholder="Select Category" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Page Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.page_description} onChange={(event, editor) => handleEditorChange("page_description", editor?.getData())} />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Page Image (408 × 680)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="page_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.page_image} />
                </div>
              </div>
              
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <h3 className="heading-text"> Section 1 </h3>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Rating <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_rating" type="text" className="form-control" placeholder="Enter Rating Number" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Total  Reviews <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_total_reviews" type="text" className="form-control" placeholder="Enter Rating Reviews" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>
              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Button Text<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_cta_text" type="text" className="form-control" placeholder="Enter Button Text" />
                </div>
              </div> */}
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor postData={postData.section1_description} onChange={(event, editor) => handleEditorChange("section1_description", editor?.getData())} />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Image (706 × 750)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section1_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section1_image} />
                </div>
              </div>
              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Button Url<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_cta_link" type="url" className="form-control" placeholder="Enter Button Url" />
                </div>
              </div> */}
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Image Alt<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section1_alt_image" type="text" className="form-control" placeholder="Enter Image Alt" />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="col-lg-12">
              <h3 className="heading-text" > Section 2 </h3>
            </div>
            <div className="row">
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Icon (72 × 72)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section2_icon1"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section2_icon1} />
                </div>


                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Heading1 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section2_title1" type="text" className="form-control" placeholder="Enter Title" />
                </div>


                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description  <small>*</small></label>
                  </div>
                  <DynamicCKEditor postData={postData.section2_description1} onChange={(event, editor) => handleEditorChange("section2_description1", editor?.getData())} />
                </div>


              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Icon (72 × 72)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section2_icon2"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section2_icon2}
                  />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Heading 2 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section2_title2" type="text" className="form-control" placeholder="Enter Title" />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description  <small>*</small></label>
                  </div>
                  <DynamicCKEditor postData={postData.section2_description2} onChange={(event, editor) => handleEditorChange("section2_description2", editor?.getData())} />
                </div>
              </div>


              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Icon (72 × 72)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section2_icon3"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section2_icon3}
                  />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Heading 3 <small>*</small></label>

                  </div>
                  <input onChange={handleChange} name="section2_title3" type="text" className="form-control" placeholder="Enter Title 3 " />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description  <small>*</small></label>
                  </div>
                  <DynamicCKEditor postData={postData.section2_description3} onChange={(event, editor) => handleEditorChange("section2_description3", editor?.getData())} />
                </div>
              </div>


              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> background Image  (1608 × 923)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section2_image"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section2_image} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Background Image Alt <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section2_alt_image" type="text" className="form-control" placeholder="Enter Alt " />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <h3 className="heading-text" >  Section 3 </h3>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Top Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section3_heading" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>


              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description <small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.section3_description}
                    onChange={(event, editor) => handleEditorChange(`section3_description`, editor.getData())} />
                </div>
              </div>

              {postData.section3_points.map((item, index) => (
                <div key={index} className="col-md-6">
                  <div className="add-page-inputs input-add-image">
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> heading <small>*</small></label>
                      </div>
                      <input className="form-control" placeholder="Heading" value={item.heading}
                        onChange={(e) => handleSection3Change(index, "heading", e.target.value)} />
                    </div>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> description <small>*</small></label>
                      </div>
                      <DynamicCKEditor data={item.description} onChange={(e, editor) =>
                        handleSection3Change(index, "description", editor.getData())} />
                    </div>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> Icon <small>*</small></label>
                      </div>
                      <CustomImageUpload
                        acceptedFormats={[".webp"]}
                        onImageChange={(e) => handleSection3Change(index, "icon", e.target.files[0])}
                        imagePreview={item.icon ? URL.createObjectURL(item.icon) : null} />
                    </div>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> image <small>*</small></label>
                      </div>
                      <CustomImageUpload
                        acceptedFormats={[".webp"]}
                        onImageChange={(e) => handleSection3Change(index, "image", e.target.files[0])}
                        imagePreview={item.image ? URL.createObjectURL(item.image) : null} />
                    </div>
                  </div>
                  {postData.section3_points.length > 1 && (
                    <button className="remove-btn" onClick={() => handleRemoveSection3(index)}>Remove </button>
                  )}
                </div>
              ))}
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <Link className="addmore-images-client" onClick={handleAddMoreSection3}>
                    Add More +
                  </Link>
                </div>
              </div>


            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <h3 className="heading-text" > Section 5 </h3>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Route Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section5_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Route Description <small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.section5_description}
                    onChange={(event, editor) => handleEditorChange(`section5_description`, editor.getData())} />
                </div>
              </div>
              {postData.section5_points.map((item, index) => (
                <div key={index} className="col-md-6">
                  <div className="add-page-inputs input-add-image">
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> heading <small>*</small></label>
                      </div>
                      <input placeholder="Heading" className="form-control" value={item.heading} onChange={(e) => handleSection5Change(index, "heading", e.target.value)} />
                    </div>
                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> description <small>*</small></label>
                      </div>
                      <DynamicCKEditor data={item.description} onChange={(e, editor) =>
                        handleSection5Change(index, "description", editor.getData())} />
                    </div>

                    <div className="add-page-inputs">
                      <div className="label-wrap-add">
                        <label> Icon <small>*</small></label>
                      </div>
                      <CustomImageUpload
                        acceptedFormats={[".webp"]}
                        onImageChange={(e) => handleSection5Change(index, "icon", e.target.files[0])}
                        imagePreview={item.icon ? URL.createObjectURL(item.icon) : null} />
                    </div>
                    {postData.section5_points.length > 1 && (
                      <button className="remove-btn" onClick={() => handleRemoveSection5(index)}>    Remove   </button>
                    )}
                  </div>
                </div>
              ))}
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <Link className="addmore-images-client" onClick={handleAddMoreSection5}>
                    Add More +
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <h3 className="heading-text" >  Section 6 </h3>
              </div>
              <div className="col-lg-6">

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Count1 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section6_stat_count1" type="text" className="form-control" placeholder="Enter Count" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Heading1 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section6_stat_heading1" type="text" className="form-control" placeholder="Enter heading " />
                </div>


                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Description  1<small>*</small></label>
                  </div>
                  <DynamicCKEditor
                    data={postData.section6_stat_description1}
                    onChange={(event, editor) =>
                      handleEditorChange("section6_stat_description1", editor.getData())} />
                </div>


              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Count2 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section6_stat_count2" type="text" className="form-control" placeholder="Enter Count" />
                </div>


                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Heading 2 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section6_stat_heading2" type="text" className="form-control" placeholder="Enter heading " />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Description2  <small>*</small></label>
                  </div>
                  <DynamicCKEditor
                    data={postData.section6_stat_description2}
                    onChange={(event, editor) =>
                      handleEditorChange("section6_stat_description2", editor.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Count3 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section6_stat_count3" type="text" className="form-control" placeholder="Enter Count" />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Heading 3 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section6_stat_heading3" type="text" className="form-control" placeholder="Enter heading " />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Description3  <small>*</small></label>
                  </div>
                  <DynamicCKEditor
                    data={postData.section6_stat_description3}
                    onChange={(event, editor) => handleEditorChange("section6_stat_description3", editor.getData())} />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Count4 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section6_stat_count4" type="text" className="form-control" placeholder="Enter Count" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Heading 4 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section6_stat_heading4" type="text" className="form-control" placeholder="Enter heading" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Stat Description 4  <small>*</small></label>
                  </div>
                  <DynamicCKEditor
                    data={postData.section6_stat_description4}
                    onChange={(event, editor) =>
                      handleEditorChange("section6_stat_description4", editor.getData())}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <h3 className="heading-text" >  Section 7 </h3>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Testimonial Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section7_heading" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Logos1 (195 × 60)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section7_icon1"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section7_icon1}
                  />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description 1 <small>*</small></label>
                  </div>
                  <DynamicCKEditor
                    data={postData.section7_description1}
                    onChange={(event, editor) =>
                      handleEditorChange("section7_description1", editor.getData())} />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Author Name 1<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section7_author1" type="text" className="form-control" placeholder="Enter Author Name" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Designation 1<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section7_designation1" type="text" className="form-control" placeholder="Enter Author Designation" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Logos2 (195 × 60)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section7_icon2"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section7_icon2}
                  />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description 2 <small>*</small></label>
                  </div>
                  <DynamicCKEditor
                    data={postData.section7_description2}
                    onChange={(event, editor) =>
                      handleEditorChange("section7_description2", editor.getData())
                    }
                  />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Author Name 2<small>*</small></label>

                  </div>
                  <input onChange={handleChange} name="section7_author2" type="text" className="form-control" placeholder="Enter Author Name" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Designation 3 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section7_designation2" type="text" className="form-control" placeholder="Enter Author Designation" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Logos2 (195 × 60)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section7_icon3"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section7_icon3}
                  />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Description 2 <small>*</small></label>
                  </div>
                  <DynamicCKEditor
                    data={postData.section7_description3}
                    onChange={(event, editor) =>
                      handleEditorChange("section7_description3", editor.getData())} />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Author Name 3<small>*</small></label>

                  </div>
                  <input onChange={handleChange} name="section7_author3" type="text" className="form-control" placeholder="Enter Author Name" />
                </div>

                <div className="add-page-inputs">
                  <div className="label-wrap-add mb-2 d-flex justify-content-between align-items-center">
                    <label>Designation 3 <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section7_designation3" type="text" className="form-control" placeholder="Enter Author Designation" />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="col-lg-12">
                  <h3 class="heading-text">   Section 8 </h3>
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Left Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>  Left Description <small>*</small></label>
                  </div>
                  <DynamicCKEditor postData={postData.section8_description} onChange={(event, editor) => handleEditorChange("section8_description", editor?.getData())} />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="col-lg-12">
                  <h3 class="heading-text">  Right Section </h3>
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Right Title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_right_side_title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Button Text <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_cta_text" type="text" className="form-control" placeholder="Enter Button Text" />
                </div>
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Button Url <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_cta_link" type="url" className="form-control" placeholder="Enter Button Url" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>  Author Image  <small>*</small></label>
                  </div>
                  <CustomImageUpload name="section8_author_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section8_author_image}
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>  Author Name <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_author" type="text" className="form-control" placeholder="Enter Name" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>  Author designation <small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="section8_designation" type="text" className="form-control" placeholder="Enter Designation" />
                </div>
              </div>
            </div>
          </div>
        </form>
        <button type="submit" form="blogAdd" className="default-btn">Publish <span></span></button>
      </div>
    </>
  );
}
